import { AppState } from 'Store'

const getAll = (state: AppState) => state.pp.blackListPartner.all
const getTotal = (state: AppState) => state.pp.blackListPartner.all.total_entries
const getRequestParams = (state: AppState) => state.pp.blackListPartner.params
const getOne = (state: AppState) => state.pp.blackListPartner.one

export const blackListPartnerSelector = {
	getAll,
	getTotal,
	getRequestParams,
	getOne,
}
